import React, { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { NotificationBell } from "./components/NotificationBell";
import { NotificationPanel } from "./components/NotificationPanel";
import { useNotificationActions } from "./_hooks/useNotificationActions";
import { useNotifications } from "./_hooks/useNotifications";

export function HeaderNotification() {
  const anchorRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const {
    sections,
    unreadCount,
    isLoading,
    isEmpty,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  } = useNotifications();

  const { dismiss, markAllAsRead, isMarkingAll } = useNotificationActions();

  const openPanel = useCallback(() => {
    refetch();
    setIsOpen(true);
  }, [refetch]);

  const closePanel = useCallback(() => setIsOpen(false), []);

  const loadMore = useCallback(() => fetchNextPage(), [fetchNextPage]);

  return (
    <>
      <NotificationBell
        ref={anchorRef}
        unreadCount={unreadCount}
        onClick={openPanel}
        label={t("main.clients.notifications")}
      />

      <NotificationPanel
        anchorEl={anchorRef.current}
        open={isOpen}
        onClose={closePanel}
        sections={sections}
        unreadCount={unreadCount}
        isLoading={isLoading}
        isEmpty={isEmpty}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        onLoadMore={loadMore}
        onDismiss={dismiss}
        onMarkAllAsRead={markAllAsRead}
        isMarkingAll={isMarkingAll}
      />
    </>
  );
}
